import PropTypes from 'prop-types'

import AtomButtom, {atomButtonDesigns} from '@s-ui/react-atom-button'
import MoleculeButtonGroup, {
  moleculeButtonGroupDisplay,
  moleculeButtonGroupSpaced
} from '@s-ui/react-molecule-button-group'

import {DESIGNS, LIST_CLASS_NAME} from '../../config.js'
import useButtonGroupFilter from '../hooks/useButtonGroupFilter.js'
import useFilterBasic from '../hooks/useFilterBasic.js'

const FilterBasicButtonGroup = ({
  allSelectionsId,
  allSelectionsLabel,
  design,
  isMultiSelect,
  onChange,
  options,
  value
}) => {
  const {hasAllOptionsChecked, hasAllSelectionsField, onSelectAll, onSelectItem} = useFilterBasic({
    allSelectionsId,
    allSelectionsLabel,
    isMultiSelect,
    onChange,
    options,
    value
  })

  const isDesignGrid = design === DESIGNS.GRID

  const {positions} = useButtonGroupFilter({allSelectionsLabel, options, value})

  const spacedButtonGroup = isDesignGrid ? {spaced: moleculeButtonGroupSpaced.SMALL} : {}

  return (
    <div className={LIST_CLASS_NAME}>
      <MoleculeButtonGroup
        fullWidth
        display={!isDesignGrid ? moleculeButtonGroupDisplay.FLEX : moleculeButtonGroupDisplay.GRID}
        {...spacedButtonGroup}
      >
        {hasAllSelectionsField && (
          <AtomButtom
            design={atomButtonDesigns.OUTLINE}
            focused={hasAllOptionsChecked}
            id={allSelectionsId}
            onClick={onSelectAll}
            value={allSelectionsId}
          >
            {allSelectionsLabel}
          </AtomButtom>
        )}
        {options.map(({icon: Icon, id, label}, index) => {
          const isFocused = value.includes(id)
          const groupPositionProp = !isDesignGrid ? {groupPosition: positions[index]} : {}

          return (
            <AtomButtom
              {...groupPositionProp}
              design={atomButtonDesigns.OUTLINE}
              focused={isFocused}
              key={id}
              id={id}
              leftIcon={Icon && <Icon />}
              onClick={() => (hasAllSelectionsField || !value.includes(id)) && onSelectItem({id})}
              value={id}
            >
              {label}
            </AtomButtom>
          )
        })}
      </MoleculeButtonGroup>
    </div>
  )
}

FilterBasicButtonGroup.displayName = 'FilterBasicButtonGroup'
FilterBasicButtonGroup.propTypes = {
  allSelectionsId: PropTypes.string,
  allSelectionsLabel: PropTypes.string,
  design: PropTypes.string,
  isMultiSelect: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      extendedInfo: PropTypes.string,
      icon: PropTypes.func,
      id: PropTypes.string.isRequired,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string.isRequired
    })
  ),
  value: PropTypes.array
}

export default FilterBasicButtonGroup
